import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import { FaUserCircle, FaBars, FaTimes } from 'react-icons/fa';
import axios from '../axiosInstance';

function Menu({ onLogout }) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isUserMenuOpen, setIsUserMenuOpen] = useState(false);
  const [isEarnMenuOpen, setIsEarnMenuOpen] = useState(false);
  const [userLevel, setUserLevel] = useState(0);

  useEffect(() => {
    axios.get(`/api/user/me`, { withCredentials: true })
      .then((response) => {
        setUserLevel(response.data.userLevel);
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des données:", error);
      });
  }, []);

  return (
    <header className="w-full p-4 flex items-center justify-start gap-8">
      {/* LOGO */}
      <div className="text-white font-bold">
        <img src="/static/media/new_logo_without_font.d2a01c8b4f6a79d54286.png" alt="CoinZUp Logo" className="w-64 h-auto" />
      </div>

      {/* Desktop Navigation */}
      <div className="hidden lg:flex items-center gap-6 ml-32">
        <NavLink to="/dashboard" className="text-white hover:text-gray-300">Dashboard</NavLink>
                {/* Earn Coinz Dropdown */}
                <div className="relative">
          <button onClick={() => setIsEarnMenuOpen(!isEarnMenuOpen)} className="text-white hover:text-gray-300">
          <span className="text-red-500 text-xs ml-1"> Earn Coinz </span>
          </button>
          {isEarnMenuOpen && (
            <div className="absolute bg-gray-800 rounded-lg shadow-lg mt-2 py-2 w-48 z-50">
              <NavLink to="/howitworks" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700">How to gain coinz?</NavLink>
                <NavLink to="/autosurf" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700">
                  AutoSurf <span className="text-red-500 text-xs ml-1">(hot)</span>
                </NavLink>
           
              <NavLink to="/draw" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700">Draw</NavLink>
              <NavLink to="/bonus" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700">Get Bonus</NavLink>
              <NavLink to="/tasks" className="block px-4 py-2 text-gray-300 hover:text-white hover:bg-gray-700">Tasks (coming soon)</NavLink>
            </div>
          )}
        </div>
        <NavLink to="/marketplace" className="text-white hover:text-gray-300">MarketPlace</NavLink>
        <NavLink to="/optionholder" className="text-white hover:text-gray-300">OptionHolders</NavLink>
        <NavLink to="/buyads" className="text-white hover:text-gray-300">Buy Ads</NavLink>

        {/* User Menu */}
        <div className="relative">
          <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="text-white text-2xl">
            <FaUserCircle />
          </button>

          {isUserMenuOpen && (
            <div className="absolute right-0 mt-2 bg-gray-800/90 rounded-lg shadow-lg p-4 w-48 z-50">
              <ul className="space-y-2 text-sm">
                <li><NavLink to="/referal" className="block text-gray-300 hover:text-white">Referral Program</NavLink></li>
                <li><NavLink to="/levelup" className="block text-gray-300 hover:text-white">Level Up</NavLink></li>
               
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Mobile Navigation */}
      <div className="lg:hidden flex items-center gap-4 ml-auto">
        <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-white text-2xl">
          {isMenuOpen ? <FaTimes /> : <FaBars />}
        </button>

        <div className="relative">
          <button onClick={() => setIsUserMenuOpen(!isUserMenuOpen)} className="text-white text-2xl">
            <FaUserCircle />
          </button>

          {isUserMenuOpen && (
            <div className="absolute right-0 mt-2 bg-gray-800/90 rounded-lg shadow-lg p-4 w-48 z-50">
              <ul className="space-y-2 text-sm">
                <li><NavLink to="/referal" className="block text-gray-300 hover:text-white">Referral Program</NavLink></li>
                <li><NavLink to="/levelup" className="block text-gray-300 hover:text-white">Level Up</NavLink></li>

               
              </ul>
            </div>
          )}
        </div>
      </div>

      {/* Burger Menu */}
      {isMenuOpen && (
        <div className="lg:hidden absolute left-0 right-0 top-16 bg-gray-800/90 p-6 rounded-lg shadow-lg z-50">
          <ul className="space-y-4 text-white">
            <li><NavLink to="/dashboard" className="block text-gray-300 hover:text-white">Dashboard</NavLink></li>
            <li>
              <button onClick={() => setIsEarnMenuOpen(!isEarnMenuOpen)} className="block w-full text-left text-gray-300 hover:text-white">
              <span className="text-red-500 text-xs ml-1"> Earn Coinz </span>
              </button>
              {isEarnMenuOpen && (
                <ul className="pl-4 mt-2 space-y-2">        
                  <li><NavLink to="/howitworks" className="block text-gray-300 hover:text-white" >How to gain coinz?</NavLink>     </li>   
                  <li><NavLink to="/autosurf" className="block text-gray-300 hover:text-white">AutoSurf <span className="text-red-500 text-xs">(hot)</span></NavLink></li>                
                  <li><NavLink to="/draw" className="block text-gray-300 hover:text-white">Draw</NavLink></li>
                  <li><NavLink to="/bonus" className="block text-gray-300 hover:text-white">Get Bonus</NavLink></li>
                  <li><NavLink to="/tasks" className="block text-gray-300 hover:text-white">Tasks (coming soon) </NavLink></li>
                </ul>
              )}
            </li>
            <li><NavLink to="/marketplace" className="block text-gray-300 hover:text-white">MarketPlace</NavLink></li>
            <li><NavLink to="/optionholder" className="block text-gray-300 hover:text-white">OptionHolders</NavLink></li>
            <li><NavLink to="/buyads" className="block text-gray-300 hover:text-white">Buy Ads</NavLink></li>
            
          </ul>
        </div>
      )}
    </header>
  );
}

export default Menu;
